import ErrorStackParser from 'error-stack-parser';
import React from 'react';

import { formatDateTime } from '@elara/client-core/lib/date-utils';
import { cn } from '@elara/client-core/lib/utils';
import { sourcePathBasename } from '@elara/core/errors';
import { prettyJson } from '@elara/core/utils';

export function PrettyPre({ value, className }: { value: string; className?: string }) {
  return (
    <div className="max-h-100 overflow-y-auto">
      <pre
        className={cn(
          'text-xs font-mono whitespace-pre-wrap break-all bg-muted/50 text-muted-foreground p-2 mr-2 rounded-md overflow-x-auto  scrollbar-thin scrollbar-thumb-muted-foreground scrollbar-track-muted-foreground/50 ',
          className,
        )}
      >
        {value}
      </pre>
    </div>
  );
}

export function PrettyStack({ error }: { error: Error }) {
  const parsedStack = ErrorStackParser.parse(error);
  return (
    <div className="flex flex-col gap-2">
      {parsedStack.map((frame, idx) => {
        return <PrettyStackFrame key={idx} frame={frame} />;
      })}
    </div>
  );
}

export function PrettyStackFrame({ frame }: { frame: StackFrame }) {
  const fileName = frame.fileName ? sourcePathBasename(frame.fileName) : undefined;
  return (
    <div className="flex items-center gap-2 text-[10px]">
      <span className="text-muted-foreground">
        {[fileName, frame.lineNumber, frame.columnNumber].filter(Boolean).join(':')}
      </span>
      <span>
        {frame.functionName} ({JSON.stringify(frame.args)})
      </span>
    </div>
  );
}

export function PrettyTable({ data }: { data: Record<string, unknown> }) {
  return (
    <div className="text-xs text-muted-foreground mt-1 flex flex-col gap-0">
      {Object.entries(data).map(([key, value]) => {
        if (value === undefined || value === null) return null;
        return (
          <div key={key} className="flex items-start gap-1 justify-start text-wrap align-top">
            <div className="flex-none">
              <strong>{key}:</strong>
            </div>{' '}
            <div className="flex-1">
              {typeof value === 'string'
                ? value
                : value instanceof Date
                  ? formatDateTime(value)
                  : React.isValidElement(value)
                    ? value
                    : prettyJson(value)}
            </div>
          </div>
        );
      })}
    </div>
  );
}
